import {SavedSettingToast} from '../saved-setting-toast/saved-setting-toast';
import type {SavedSettingToastState} from '../saved-setting-toast/saved-setting-toast';
import {Body} from '../typography/body';

export const renderHeader = (
    header?: string | null,
    headerButton?: React.ReactNode | null,
    saveState?: SavedSettingToastState | null,
    setSaveState?: ((state: SavedSettingToastState) => void) | null
) => {
    if (!header) return null;

    const headerText = <Body size='small'>{header}</Body>;

    if (headerButton) {
        return (
            <div className='flex full-width align-center justify-sb'>
                <div>
                    {saveState ? (
                        // @ts-expect-error
                        <SavedSettingToast state={saveState} onStateChange={setSaveState}>
                            {headerText}
                        </SavedSettingToast>
                    ) : (
                        headerText
                    )}
                </div>
                <div>{headerButton}</div>
            </div>
        );
    }

    return saveState ? (
        // @ts-expect-error
        <SavedSettingToast state={saveState} onStateChange={setSaveState}>
            {headerText}
        </SavedSettingToast>
    ) : (
        headerText
    );
};
